module.exports = __webpack_public_path__ + "assets/images/White-bplus_1.4aad8c96.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/White-bplus_1.png
// module id = 3097
// module chunks = 1